import { StartClient } from "@tanstack/react-start/client"
import { hydrateRoot } from "react-dom/client"
import { initSentry } from "@/monitoring"

initSentry()

hydrateRoot(document, <StartClient />)
